import React, { useMemo } from 'react'

import { ShopCountry, ShopID } from '@cbgms/base/shop-id'

interface IContextValue {
  shopCountry: ShopCountry
  hasBeenProvided: boolean
}

const defaultShopCountryContext: IContextValue = {
  shopCountry: ShopCountry.NL,
  hasBeenProvided: false
}

export const ShopCountryContext = React.createContext<IContextValue | undefined>(defaultShopCountryContext)

interface Props {
  shopID: string
}

export const ShopCountryContextProvider = ({ children, shopID }: React.PropsWithChildren<Props>) => {
  const country = ShopID.from(shopID)?.country
  const isProvided = !!country
  const contextValue = useMemo(() => ({ shopCountry: country || ShopCountry.NL, hasBeenProvided: isProvided }), [country, isProvided])

  return <ShopCountryContext.Provider value={contextValue}>{children}</ShopCountryContext.Provider>
}

export const useShopCountryContext = () => {
  const context = React.useContext(ShopCountryContext)
  if (context === undefined || !context.hasBeenProvided) {
    console.error('useShopCountryContext must be used within an ShopCountryContext')
  }

  return context
}

export const useOptionalShopCountryContext = () => {
  // we don't warn when asking for optional context.
  // it's expected that the consumer will check if the value is provided
  const context = React.useContext(ShopCountryContext)
  return context
}
